import { useContext } from 'react';
import TranslationContext, { TranslationData } from './TranslationContext';

function useCurrentLocale() {
  const context = useContext<TranslationData>(TranslationContext);

  if (context === undefined) {
    throw new Error('useCurrentLocale: TranslationProvider missing');
  }

  return context.locale;
}

export default useCurrentLocale;
